import { useEffect, useState } from "react";

const OptimizedDiv = ({
  children,
  highResImageSrc,
  lowResImageSrc,
  className,
  gradient = true,
}) => {
  const [bgImg, setBgImg] = useState(lowResImageSrc);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = highResImageSrc;

    img.onload = () => {
      setBgImg(highResImageSrc);
      setIsLoaded(true);
    };
  }, [highResImageSrc]);

  return (
    <div className={className}>
      {children}
      <style>
        {`
          .${className}::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: ${
              gradient
                ? "linear-gradient(0deg, rgba(0, 0, 0, 0.713) 0%, rgba(0, 0, 0, 0.751) 100%) ,"
                : ""
            } url(${bgImg});
            background-size: cover;
            background-position: center;
            transition: filter 0.3s ease-in-out;
            filter: ${isLoaded ? "blur(0)" : "blur(5px)"};
            z-index: -1;
          }
        `}
      </style>
    </div>
  );
};

export default OptimizedDiv;
